import React, { useEffect, useRef, useState } from "react";
import {
  ChangeBlogStatus,
  GetBlogsByStatus,
} from "../../../api/blogApi/userBlogReq";
import { ChangeBlogVisibility } from "../../../api/blogApi/userBlogReq";
import { GetUpdateReqContent } from "../../../api/ContentApi/contentApi";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../app/components/Pagination/Pagination";
import {
  blogVisibilityStatus,
  CommonStatus,
  contentCategoryId,
} from "../../../app/Enums/StatusEnums";
import { toast } from "react-toastify";
import { routePath } from "../../../app/routes/routepath";
import RejectBlogModal from "../../../app/components/FeedbackModal/RejectBlogModal/RejectBlogModal";
import BlogActionModal from "../../../app/components/FeedbackModal/BlogActionModal/BlogActionModal";
import "../../Users/Users.css";
import LoadingSpinner from "../../../app/components/Loader/LoadingSpinner";
import viewSvg from "../../../assets/icons/view.svg";
import { RoleId } from "../../../app/Enums/RoleId";
import {
  Ban,
  CheckCircle,
  ClipboardEdit,
  Clock,
  Eye,
  Lock,
  Unlock,
} from "lucide-react";
function UserBlog() {
  const navigate = useNavigate();
  const navigateDashboard = () => {
    navigate(routePath.dashboard);
  };
  const user_id = localStorage.getItem("UserId");

  const [Blog, setBlog] = useState([]);
  const [authorId, setAuthorId] = useState(null);
  const [statusId, setStatusId] = useState(
    Number(localStorage.getItem("userBlogStatus")) || CommonStatus.Pending,
  );
  const [pageNumber, setPageNumber] = useState(
    Number(localStorage.getItem("userBlogPageNumber")) || 1,
  );
  const [pageSize, setPageSize] = useState(
    Number(localStorage.getItem("userBlogPageSize")) || 10,
  );
  const [totalRows, setTotalRows] = useState(0);
  // const totalPages = Math.ceil(totalRows / pageSize);
  console.log("The page number is :", pageNumber);

  const [showBlogActionModal, setShowBlogActionModal] = useState(false);
  const [showRejectBlogModal, setShowRejectBlogModal] = useState(false);
  const [selectedBlogId, setSelectedBlogId] = useState(null);

  //for updated content show
  const [updateReqData, setUpdateReqData] = useState([]);
  const [updateReqDisplay, setUpdateReqDisplay] = useState(false);
  const [updatePageNumber, setUpdatePageNumber] = useState(
    Number(localStorage.getItem("userBlogUpdatePageNumber")) || 1,
  );
  const [updatePageSize, setUpdatePageSize] = useState(
    Number(localStorage.getItem("userBlogUpdatePageSize")) || 10,
  );
  const [updateTotalRows, setUpdateTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const tableRef = useRef(null);
  const [reqData, setReqData] = useState({
    categoryId: contentCategoryId.blog,
    statusId: CommonStatus.Pending,
    pageNumber: updatePageNumber,
    pageSize: updatePageSize,
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState("");
  const roleId = Number(localStorage.getItem("RoleId"));
  const fetchBlogsByStatus = async () => {
    try {
      const response = await GetBlogsByStatus({
        author_Id: authorId,
        status_id: statusId,
        pageNumber: pageNumber,
        pageSize: pageSize,
      });
      console.log("API Response:", response);

      if (response?.data?.result === 1) {
        console.log("Blogs by Status:", response.data.result_value);
        setTotalRows(response.data.totalRows);
        setBlog(response.data.result_value);
        setIsLoading(false);
      } else {
        console.log("No Blogs found.");
        setBlog([]);
        setTotalRows(0);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch blogs:", error);
      setBlog([]);
      setTotalRows(0);
    }
  };

  useEffect(() => {
    localStorage.setItem("userBlogStatus", statusId);
    localStorage.setItem("userBlogPageNumber", pageNumber);
    localStorage.setItem("userBlogPageSize", pageSize);

    localStorage.setItem("userBlogUpdatePageNumber", updatePageNumber);

    localStorage.setItem("userBlogUpdatePageSize", updatePageSize);
  }, [statusId, pageNumber, pageSize, updatePageNumber, updatePageSize]);

  useEffect(() => {
    if (statusId === 5) {
      const updatedReqData = {
        categoryId: contentCategoryId.blog,
        statusId: CommonStatus.Pending,
        pageNumber: updatePageNumber,
        pageSize: updatePageSize,
      };
      getUpdateReqestData(updatedReqData);
    }
  }, [statusId, updatePageNumber, updatePageSize]);

  useEffect(() => {
    fetchBlogsByStatus();
  }, [statusId, authorId, pageNumber, pageSize]);

  const handleStatusChange = (e) => {
    /* setIsLoading(true); */
    const selectedValue = e.target.value;
    if (selectedValue == "5") {
      setStatusId(selectedValue);
      getUpdateReqestData(reqData);
      setUpdatePageNumber(1);
      //  setUpdateReqDisplay(true);
    } else {
      setStatusId(selectedValue === "0" ? null : Number(selectedValue));
      setPageNumber(1);
      setUpdateReqDisplay(false);
    }
  };

  const getUpdateReqestData = async (data) => {
    try {
      const response = await GetUpdateReqContent(data);
      if (response.data.result == 1) {
        setUpdateReqData(response.data.result_value);
        setUpdateReqDisplay(true);
        setUpdateTotalRows(
          response.data.totalRecords || response.data.totalRows,
        );
      } else {
        toast.error("Something went wrong. Try again.");
      }
    } catch (error) {
      console.error("Failed to fetch update request data:", error);
      toast.error("Error fetching update requests.");
    }
  };

  const handleVisibilityToggle = async (blog_id, is_active) => {
    const newIsActive = !is_active;
    const numericValue = newIsActive ? 1 : 0;
    try {
      const response = await ChangeBlogVisibility({
        blog_id: blog_id,
        is_active: numericValue,
        user_id: user_id,
      });

      if (is_active == true) {
        toast.success("Blog Disabled Successfully");
      } else {
        toast.success("Blog Enabled Successfully");
      }
      fetchBlogsByStatus();
    } catch (error) {
      console.error("Failed to fetch blogs:", error);
      toast.error("something went wrong try again");
    }
  };
  // Handle opening the action modal for pending blogs
  const handlePendingBlogClick = (blog_id) => {
    setSelectedBlogId(blog_id);
    setShowBlogActionModal(true);
  };

  const handleBlogStatusChange = async (
    blog_id,
    status_id,
    blog_reject_reason = null,
  ) => {
    try {
      if (status_id == CommonStatus.Rejected) {
        setSelectedBlogId(blog_id);
        setShowRejectBlogModal(true);
        return;
      }
      const response = await ChangeBlogStatus({
        blog_id: blog_id,
        status_id: status_id,
        user_id: user_id,
        blog_reject_reason: blog_reject_reason,
      });

      if (response?.data?.result === 1) {
        toast.success(
          `Blog successfully ${CommonStatus[status_id].toLowerCase()}!`,
        );
        fetchBlogsByStatus();
        console.log("API Response ChangeBlogStatus:", response);
      } else {
        toast.error("An unknown error occurred.");
      }
    } catch (error) {
      console.error("Failed to update blog status:", error);
      toast.error("Please try again.");
    }
  };
  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html || "";
    return txt.value;
  };
  const handleApproveFromModal = () => {
    if (!selectedBlogId) return;

    handleBlogStatusChange(selectedBlogId, CommonStatus.Approved);
    setShowBlogActionModal(false);
    setSelectedBlogId(null);
  };

  // Handle reject from action modal (show reject reason modal)
  const handleRejectFromModal = () => {
    setShowBlogActionModal(false);
    setShowRejectBlogModal(true);
    // Keep selectedBlogId for the reject modal
  };

  const handleRejectWithReason = async (reason) => {
    if (!selectedBlogId) return;

    try {
      const response = await ChangeBlogStatus({
        blog_id: selectedBlogId,
        status_id: CommonStatus.Rejected,
        user_id: user_id,
        blog_reject_reason: reason,
      });
      console.log("API Response ChangeBlogStatus:", response);

      if (response?.data?.result === 1) {
        toast.success("Blog successfully rejected!");
        fetchBlogsByStatus();
      } else {
        toast.error("An unknown error occurred.");
      }
    } catch (error) {
      console.error("Failed to update blog status:", error);
      toast.error("Please try again.");
    } finally {
      setShowRejectBlogModal(false);
      setSelectedBlogId(null);
    }
  };

  const handleCloseActionModal = () => {
    setShowBlogActionModal(false);
    setSelectedBlogId(null);
  };
  const handleCloseRejectModal = () => {
    setShowRejectBlogModal(false);
    setSelectedBlogId(null);
  };

  const handleUpdateReview = (blog) => {
    navigate(routePath.UpdateReview, {
      state: { content: blog, category: contentCategoryId.blog },
    });
  };

  const handleView = (blog_id) => {
    navigate(routePath.ViewAdminBlog, {
      state: { blogId: blog_id, returnPath: routePath.userBlog },
    });
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPageNumber(1);
  };

  const handleUpdatePageSizeChange = (size) => {
    setUpdatePageSize(size);
    setUpdatePageNumber(1);
  };

  useEffect(() => {
    setPageNumber(1);
  }, [pageSize]);

  useEffect(() => {
    setUpdatePageNumber(1);
  }, [updatePageSize]);

  useEffect(() => {
    tableRef.current?.scrollTo({ top: 0, behavior: "smooth" });
  }, [pageNumber, pageSize]);

  const openModal = (description) => {
    setSelectedDescription(description);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDescription("");
  };

  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="main-out-wraper">
          <div className="role-box">
            <h2>User Blog</h2>
            <div className="search-filter-section">
              <div className="form-wraper">
                <label>Status</label>
                <select onChange={handleStatusChange} value={statusId}>
                  <option value={CommonStatus.Pending}>Pending</option>
                  <option value={CommonStatus.Approved}>Approved</option>
                  <option value={CommonStatus.Rejected}>Rejected</option>
                  <option value={5}>Update Request</option>
                </select>
              </div>
            </div>
          </div>

          <div className="main_widget">
            <div className="main_widget_body">
              <div className="table-responsive" ref={tableRef}>
                <table>
                  <thead>
                    <tr>
                      <th style={{ minWidth: "47px" }}>S. No</th>
                      <th style={{ minWidth: "430px" }}>Title</th>
                      <th style={{ minWidth: "180px" }}>Cover Image</th>
                      <th style={{ minWidth: "430px" }}>Summary</th>
                      <th style={{ minWidth: "420px" }}>Author</th>

                      {/* <th className="action_th">Action</th> */}
                      {updateReqDisplay ? (
                        <th style={{ minWidth: "200px" }}>Action</th>
                      ) : (
                        <>
                          {statusId === CommonStatus.Approved && (
                            <th style={{ minWidth: "200px" }}>Status</th>
                          )}
                          {statusId === CommonStatus.Pending && (
                            <th style={{ minWidth: "120px" }}>Status</th>
                          )}
                          {statusId === CommonStatus.Rejected && (
                            <th style={{ minWidth: "200px" }}>
                              Rejection Reason
                            </th>
                          )}
                          {!updateReqDisplay && (
                            <th style={{ minWidth: "200px" }}>Action</th>
                          )}
                        </>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {!updateReqDisplay
                      ? Blog.map((blog, index) => (
                          <tr key={index}>
                            <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                            <td style={{ wordBreak: "break-all" }}>
                              {decodeHtml(blog.blog_title)}
                            </td>
                            <td>
                              <img
                                src={
                                  blog.blog_coverImage ||
                                  "https://placehold.co/100x60?text=No\nImage"
                                }
                                alt="cover"
                                className="CoverImage"
                              />
                            </td>
                            <td style={{ wordBreak: "break-all" }}>
                              {/* {blog.blog_description} */}
                              {decodeHtml(blog.blog_description).length > 80 ? (
                                <>
                                  {decodeHtml(blog.blog_description).slice(
                                    0,
                                    80,
                                  )}
                                  ...
                                  <span
                                    className="see-more"
                                    onClick={() =>
                                      openModal(
                                        decodeHtml(blog.blog_description),
                                      )
                                    }
                                  >
                                    {" "}
                                    See more
                                  </span>
                                </>
                              ) : (
                                decodeHtml(blog.blog_description)
                              )}
                            </td>
                            <td>{blog.author_name}</td>

                            {statusId === CommonStatus.Approved &&
                            roleId === RoleId.Admin ? (
                              <td>
                                {/* <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={blog.is_active === true}
                                  onChange={() =>
                                    handleVisibilityToggle(
                                      blog.blog_id,
                                      blog.is_active
                                    )
                                  }
                                />
                                <span className="slider"></span>
                              </label> */}
                                {blog.is_active === true ? (
                                  /* DISABLE */
                                  <div
                                    className="tooltip-wrapper"
                                    style={{ "--bg-color": "#dc2626" }}
                                    onClick={() =>
                                      //  handleEnableDisable(item.blogId, blogVisibilityStatus.disable)
                                      handleVisibilityToggle(
                                        blog.blog_id,
                                        blog.is_active,
                                      )
                                    }
                                  >
                                    <Unlock className="icon icon-approved" />
                                    <span className="tooltip-text">
                                      Disable
                                    </span>
                                  </div>
                                ) : (
                                  /* ENABLE */
                                  <div
                                    className="tooltip-wrapper"
                                    style={{ "--bg-color": "#22c55e" }}
                                    onClick={() =>
                                      // handleEnableDisable(item.blogId, blogVisibilityStatus.enable)
                                      handleVisibilityToggle(
                                        blog.blog_id,
                                        blog.is_active,
                                      )
                                    }
                                  >
                                    <Lock className="icon icon-deactivated" />
                                    <span className="tooltip-text">Enable</span>
                                  </div>
                                )}
                              </td>
                            ) : (
                              statusId === CommonStatus.Approved &&
                              roleId === RoleId.SuperAdmin && (
                                <td>
                                  {blog.is_active === true ? (
                                    <div
                                      id="EnableVisibility"
                                      className="tooltip-wrapper"
                                      style={{ "--bg-color": "#16a34a" }}
                                    >
                                      <CheckCircle className="icon icon-active" />
                                      <span className="tooltip-text">
                                        Active
                                      </span>
                                    </div>
                                  ) : (
                                    <div
                                      id="DisableVisibility"
                                      className="tooltip-wrapper"
                                      style={{ "--bg-color": "#dc2626" }}
                                    >
                                      <Ban className="icon icon-deactivated" />
                                      <span className="tooltip-text">
                                        Inactive
                                      </span>
                                    </div>
                                  )}
                                </td>
                              )
                            )}

                            {statusId === CommonStatus.Pending &&
                            roleId === RoleId.Admin ? (
                              <td>
                                <div
                                  className="tooltip-wrapper"
                                  onClick={() =>
                                    handlePendingBlogClick(blog.blog_id)
                                  }
                                  style={{ "--bg-color": "#f59e0b" }}
                                >
                                  <Clock className="icon icon-pending" />
                                  <span className="tooltip-text">Pending</span>
                                </div>
                              </td>
                            ) : (
                              roleId === RoleId.SuperAdmin &&
                              statusId === CommonStatus.Pending && (
                                <td>
                                  <div
                                    className="tooltip-wrapper"
                                    style={{ "--bg-color": "#f59e0b" }}
                                  >
                                    <Clock className="icon icon-pending" />
                                    <span className="tooltip-text">
                                      Pending
                                    </span>
                                  </div>
                                </td>
                              )
                            )}
                            {statusId === CommonStatus.Rejected && (
                              <td>{blog.blog_reject_reason || "N/A"}</td>
                            )}
                            <td>
                              <div
                                className="tooltip-wrapper"
                                style={{ "--bg-color": "#002954" }}
                                onClick={() => handleView(blog?.blog_id)}
                              >
                                <Eye className="icon icon-view" />
                                <span className="tooltip-text">
                                  View User Blog
                                </span>
                              </div>

                              {/* <img className="table-icon" onClick={() => handleView(blog?.blog_id)} src={viewSvg} alt="view" /> */}
                            </td>
                          </tr>
                        ))
                      : updateReqData.map((blog, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{blog.updatedTitle}</td>
                            <td>
                              <img
                                src={
                                  blog.updatedCoverImage ||
                                  "https://placehold.co/100x60?text=No\nImage"
                                }
                                alt="cover"
                                className="CoverImage"
                              />
                            </td>
                            <td style={{ wordBreak: "break-all" }}>
                              {/* {blog.updatedDescription} */}
                              {decodeHtml(blog.updatedDescription).length >
                              80 ? (
                                <>
                                  {decodeHtml(blog.updatedDescription).slice(
                                    0,
                                    80,
                                  )}{" "}
                                  <span
                                    className="see-more"
                                    onClick={() =>
                                      openModal(
                                        decodeHtml(blog.updatedDescription),
                                      )
                                    }
                                  >
                                    {" "}
                                    See more
                                  </span>
                                </>
                              ) : (
                                blog.updatedDescription
                              )}
                            </td>
                            <td>{blog.userName}</td>
                            <td>
                              <div
                                className="tooltip-wrapper"
                                style={{ "--bg-color": "#2563eb" }}
                                onClick={() => handleUpdateReview(blog)}
                              >
                                <ClipboardEdit className="icon icon-review-update" />
                                <span className="tooltip-text">
                                  Review Update
                                </span>
                              </div>
                            </td>
                          </tr>
                        ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {showBlogActionModal && (
            <BlogActionModal
              onClose={handleCloseActionModal}
              onApprove={handleApproveFromModal}
              onReject={handleRejectFromModal}
              blogTitle={
                Blog.find((blog) => blog.blog_id === selectedBlogId)?.blog_title
              }
            />
          )}

          {showRejectBlogModal && (
            <RejectBlogModal
              onClose={handleCloseRejectModal}
              onSubmit={handleRejectWithReason}
              blogTitle={
                Blog.find((blog) => blog.blog_id === selectedBlogId)?.blog_title
              }
            />
          )}
          {!updateReqDisplay ? (
            <Pagination
              currentPage={pageNumber}
              totalPages={Math.ceil(totalRows / pageSize)}
              pageSize={pageSize}
              onPageChange={setPageNumber}
              // onPageSizeChange={setPageSize}
              onPageSizeChange={handlePageSizeChange}
            />
          ) : (
            <Pagination
              currentPage={updatePageNumber}
              totalPages={Math.ceil(updateTotalRows / updatePageSize)}
              pageSize={updatePageSize}
              onPageChange={setUpdatePageNumber}
              // onPageSizeChange={setUpdatePageSize}
              onPageSizeChange={handleUpdatePageSizeChange}
            />
          )}
        </div>
      )}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
            <h2>Summary</h2>
            <p>{decodeHtml(selectedDescription)}</p>{" "}
            <div className="d-flex justify-content-center">
              <button className="primary_btn" onClick={closeModal}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default UserBlog;
